import gql from 'graphql-tag';
import { AwardFullFragment } from '../fragments/AwardFullFragment';

export const AwardDetailQuery = gql`
	query AwardDetailQuery($id: ID!) {
		entity: node(id: $id) {
			...AwardFullFragment
		}
	}
	${AwardFullFragment}
`;


